import React from 'react';
import OrderTable from '../components/OrderTable.js';

export default function OrderTracking() {
  return <OrderTable />;
}
